'use strict';

function _allEqualInString(str) {
    return Odigeo._.every(str.split(''), function(char) {
        return char === str[0];
    });
}

function _checkSubstract(substract) {
    return (substract === 10 || substract === 11) ? 0 : substract;
}

function _calulateSumAndSubstract(substract, n, cpfFix) {
    var sum = 0;
    for (var i = 1; i <= n; i++) {
        sum = sum + parseInt(cpfFix.substring(i - 1, i)) * (n + 2 - i);
        substract = (sum * 10) % 11;
    }
    return substract;
}

function _validSubstract(substract, cpf, first, second) {
    return substract === parseInt(cpf.substring(first, second));
}

function checkCpf(substract, n, cpfFix) {
    substract = _checkSubstract(_calulateSumAndSubstract(substract, n, cpfFix));
    return _validSubstract(substract, cpfFix, n, n + 1);
}

var isValidCpf = function(cpfFix) {
    var CPFCONSTANT = 11;
    var substract = 0;

    if (cpfFix.length !== CPFCONSTANT || _allEqualInString(cpfFix)) {
        return false;
    } else {
        checkCpf(substract, 9, cpfFix);
        return checkCpf(substract, 10, cpfFix);
    }
};

module.exports = {
    isValidCpf: isValidCpf,
};
